export const EXPENSE_RECEIPTS_TEXT = Object.freeze({
  page: {
    title: 'Pagos',
    subtitle: 'Control de recibos y complementos de pago de egresos.',
  },
  create: {
    page: {
      title: 'Nuevo pago de egresos',
      subtitle: 'Registra un nuevo pago de egresos y su información de facturación.',
    },
    headerActions: {
      back: 'Regresar',
    },
    ui: {
      documentSupplierCard: {
        title: 'Documento / Proveedor',
        fields: {
          voucherType: 'Tipo de comprobante',
          payTo: 'Pago a',
          supplier: 'Proveedor',
          collaborator: 'Colaborador',
          pendingAmount: 'Monto Pendiente',
          fiscalData: 'Datos fiscales',
          supplierLabel: 'Proveedor',
          rfc: 'RFC',
          businessName: 'Razón social',
          taxRegime: 'Régimen fiscal',
          cfdiUse: 'Uso CFDI',
          postalCode: 'Código postal',
        },
        placeholders: {
          supplier: 'Selecciona proveedor',
          collaborator: 'Selecciona colaborador',
          receiver: 'Selecciona dato fiscal',
        },
        actions: {
          showAll: 'Ver todo',
          hide: 'Ocultar',
          editFiscalData: 'Editar dato fiscal',
        },
        emptyOption: 'Sin opción disponible',
        emptyState: 'Selecciona un dato fiscal para visualizar su información.',
        supplierPendingPrefix: 'Pendiente',
      },
      paymentInfoCard: {
        title: 'Información del Pago',
        fields: {
          amount: 'Monto a pagar',
          date: 'Fecha',
          paymentForm: 'Forma de pago',
          paymentAccount: 'Cuenta receptora',
          operationNumber: 'No. operación / referencia',
          folioPrefix: 'Folio',
        },
        placeholders: {
          paymentForm: 'Selecciona forma de pago',
          paymentAccount: 'Selecciona cuenta receptora',
          operationNumber: 'Captura número de operación',
          date: 'Selecciona fecha',
        },
        emptyOption: 'Sin opción disponible',
      },
      applicationCard: {
        title: 'Aplicación del pago',
        loading: 'Cargando elementos pendientes...',
        emptyCfdi: 'No hay CFDI pendientes o parcialmente pagados para el proveedor seleccionado.',
        emptySimpleNote: 'No hay notas simples pendientes o parcialmente pagadas para el proveedor seleccionado.',
        unknownBusiness: 'Sin negocio relacionado',
        table: {
          headers: {
            date: 'FECHA',
            folio: 'FOLIO',
            category: 'CATEGORIA',
            business: 'NEGOCIO',
            concept: 'CONCEPTO',
            total: 'TOTAL',
            pending: 'SALDO PENDIENTE',
            applied: 'MONTO A PAGAR',
          },
        },
      },
      infoCard: {
        title: 'Información',
        fields: {
          type: 'Tipo',
          date: 'Fecha',
          series: 'Serie',
          folio: 'Folio',
          cfdiFolio: 'Folio CFDI',
        },
        placeholders: {
          type: 'Selecciona tipo',
          date: 'Selecciona fecha',
          series: 'Selecciona serie',
        },
        voucherTypes: {
          cfdi: 'CFDI',
          simpleNote: 'Nota simple',
          foreign: 'Comp. Extranjero',
        },
        emptyValue: '-',
      },
      conceptsCard: {
        title: 'Conceptos',
        addButton: 'Concepto',
        menu: {
          title: 'Más acciones',
          cfdiRelated: 'CFDI Relacionado',
        },
        empty: 'Por el momento no hay conceptos por mostrar.',
        toasts: {
          cfdiRelatedPending: 'CFDI Relacionado se conectará en el siguiente paso.',
        },
      },
      bottomSection: {
        totalTitle: 'TOTAL',
      },
      footerActions: {
        submit: 'Registrar pago',
        submitCfdi: 'Registrar pago con CFDI',
      },
      confirmModal: {
        title: 'Confirmar registro de pago',
        titleCfdi: 'Confirmar registro de pago con CFDI',
        subtitle: 'Valida los datos antes de registrar el pago.',
        closeAriaLabel: 'Cerrar confirmación',
        sections: {
          supplier: 'Proveedor y documento',
          paymentInfo: 'Información del pago',
          applications: 'Aplicaciones del pago',
        },
        labels: {
          supplier: 'Proveedor',
          collaborator: 'Colaborador',
          voucherType: 'Documento',
          date: 'Fecha',
          paymentForm: 'Forma de pago',
          paymentAccount: 'Cuenta receptora',
          operationNumber: 'No. operación',
          currency: 'Moneda',
          exchangeRate: 'Tipo de cambio',
          total: 'Total a registrar',
        },
        table: {
          headers: {
            document: 'DOCUMENTO',
            business: 'NEGOCIO',
            concept: 'CONCEPTO',
            amount: 'MONTO',
          },
        },
        empty: 'No hay elementos para aplicar.',
        buttons: {
          cancel: 'Cancelar',
          confirm: 'Confirmar pago',
          confirmCfdi: 'Confirmar y timbrar',
        },
      },
    },
    validation: {
      serialRequired: 'Selecciona una serie válida para registrar el pago.',
      receiverRequired: 'Selecciona un receptor con datos de facturación.',
      cfdiRequired: 'El tipo debe ser CFDI para registrar pago con CFDI.',
      foreignVoucherPending: 'El registro de pagos con comprobante extranjero estará disponible próximamente.',
      applicationRequired: 'Debes aplicar al menos un elemento para registrar el pago.',
      amountRequired: 'El monto aplicado debe ser mayor a cero.',
      appliedAmountMismatch: 'Tu pago aun no esta completamente distribuido. Ajusta los montos aplicados para que coincidan con el monto a pagar.',
    },
    toast: {
      submitPending: 'Registro de pago se conectará en el siguiente paso.',
      submitCfdiPending: 'Registro de pago con CFDI se conectará en el siguiente paso.',
      submitSuccess: 'Pago registrado correctamente.',
      submitError: 'No fue posible registrar el pago.',
    },
  },
  detail: {
    page: {
      title: 'Pago',
      dateFallback: '-',
    },
    sectionTabsAriaLabel: 'Secciones del detalle de pago',
    tabs: {
      detail: 'Detalle',
      shipping: 'Envios',
      documents: 'Documentos',
      history: 'Historial',
    },
    breadcrumb: {
      ariaLabel: 'Ruta de pago',
      backLabel: 'Volver',
    },
    status: {
      active: 'VIGENTE',
      canceled: 'CANCELADO',
    },
    headerActions: {
      download: 'Descargar',
      downloadPdfShort: 'PDF',
      downloadXml: 'Descargar XML',
      send: 'Enviar',
      sendWhatsapp: 'Enviar por WhatsApp',
      cancel: 'Cancelar',
    },
    header: {
      moreActionsTitle: 'Más acciones',
      cancelImportantHint: 'Esta acción cancela el pago de egreso y no se puede deshacer.',
    },
    cancelConfirm: {
      title: 'Cancelar pago de egreso',
      subtitle: 'Confirma para continuar con esta operación.',
      message: 'El pago de egreso se cancelará, los gastos relacionados volverán a pendiente y se eliminarán sus relaciones de pago. Esta acción no se puede deshacer.',
      confirm: 'Sí, cancelar pago',
      cancel: 'Volver',
    },
    cards: {
      summary: {
        title: 'Resumen',
      },
      concepts: {
        title: 'Conceptos',
        table: {
          headers: {
            date: 'Fecha',
            folio: 'Folio',
            category: 'Categoria',
            business: 'Negocio',
            concept: 'Concepto',
            amount: 'Monto',
          },
          empty: 'No hay conceptos relacionados para este pago.',
        },
      },
      operation: {
        title: 'Operación',
        fields: {
          status: 'Estado',
          supplier: 'Proveedor',
          business: 'Negocio asociado',
          sent: 'Enviada',
          lastSent: 'Último envío',
          relatedPayments: 'Relacion',
          paymentForm: 'Forma de pago',
          paymentAccount: 'Cuenta bancaria',
          operationNumber: 'No. operación',
          date: 'Fecha',
          total: 'Total',
        },
      },
      fiscalSummary: {
        title: 'Resumen fiscal',
        sections: {
          emitter: 'Emisor',
          bankData: 'Datos bancarios',
        },
        fields: {
          receiverRfc: 'RFC receptor',
          issueDate: 'Fecha de emision',
          folio: 'Folio',
          cfdiFolio: 'Folio CFDI',
          uuid: 'UUID',
          currencyExchange: 'Moneda / Tipo de cambio',
          rfc: 'RFC',
          businessName: 'Razón social',
          taxRegime: 'Régimen fiscal',
          fiscalResidence: 'Dirección fiscal',
          bank: 'Banco',
          orderingBank: 'Banco ordenante',
          orderingBankRfc: 'RFC banco ordenante',
          orderingBankAccount: 'Cuenta ordenante',
          beneficiaryBankRfc: 'RFC banco beneficiario',
          beneficiaryAccount: 'Cuenta beneficiario',
          bankAccount: 'Cuenta',
        },
        actions: {
          showAll: 'Ver todo',
          showLess: 'Ver menos',
        },
      },
    },
    tabPanels: {
      shipping: {
        title: 'Envios',
        subtitle: 'Registro cronologico de envios para este recibo de pago.',
      },
      documents: {
        title: 'Documentos',
        subtitle: 'Listado de archivos y documentos relacionados con este pago de egreso.',
      },
      history: {
        title: 'Historial',
        subtitle: 'Registro cronologico de movimientos del recibo de pago.',
      },
    },
    shipping: {
      loading: 'Cargando envios...',
      empty: 'Sin envios para este recibo de pago.',
      table: {
        headers: {
          index: '#',
          date: 'Fecha',
          module: 'Canal',
          event: 'Estatus',
          description: 'Descripcion',
          user: 'Usuario',
        },
      },
      fallback: {
        date: '-',
        module: 'Correo',
        event: 'Pendiente',
        description: 'Envio registrado',
        actor: 'Sistema',
      },
    },
    history: {
      loading: 'Cargando historial...',
      empty: 'Sin movimientos registrados para este recibo de pago.',
      table: {
        headers: {
          index: '#',
          date: 'Fecha',
          module: 'Modulo',
          event: 'Evento',
          description: 'Descripcion',
          user: 'Usuario',
        },
      },
      fallback: {
        date: '-',
        module: 'General',
        event: 'Cambio',
        description: 'Actividad registrada',
        actor: 'Sistema',
      },
    },
    toast: {
      loadExpenseReceiptError: 'No fue posible cargar el detalle del pago.',
      actions: {
        download: 'La descarga del pago se conectará en el siguiente paso.',
        downloadPdf: 'La descarga de PDF del pago se conectará en el siguiente paso.',
        downloadXml: 'La descarga de XML del pago se conectará en el siguiente paso.',
        send: 'El envío del pago se conectará en el siguiente paso.',
        sendWhatsapp: 'El envío por WhatsApp se conectará en el siguiente paso.',
        cancel: 'La cancelación del pago se conectará en el siguiente paso.',
      },
    },
  },
  headerActions: {
    payment: 'Pagar',
    export: 'Exportar',
    exportDownload: 'Descargar',
  },
  toasts: {
    downloadRequestCreated: 'Tu solicitud de descarga fue registrada y comenzará a procesarse en segundo plano.',
    downloadRequestError: 'No fue posible preparar la descarga de documentos.',
    downloadPackageError: 'No fue posible descargar el paquete seleccionado.',
    retryPackageSuccess: 'El paquete se marcó para reintento.',
    retryPackageError: 'No fue posible reintentar el paquete.',
    regenerateSuccess: 'Se generó una nueva solicitud con los parámetros de la descarga anterior.',
    regenerateError: 'No fue posible generar nuevamente la descarga.',
    openDetailError: 'No fue posible abrir el detalle del recibo de pago.',
    paymentReferenceFallback: 'sin folio',
    viewExpenseReceipt: (reference) => `Ver recibo: ${reference}`,
    downloadFiles: (reference) => `Descargar recibo: ${reference}`,
    downloadXml: (reference) => `Descargar XML: ${reference}`,
    downloadPdf: (reference) => `Descargar PDF: ${reference}`,
  },
  downloadModal: {
    title: 'Descargar documentos',
    closeAriaLabel: 'Cerrar modal de descarga de documentos',
    contextMessage: 'Se descargarán los documentos correspondientes a los resultados de la pestaña y filtros actuales.',
    lastDownloadTitle: 'Última descarga',
    fallbackScopeLabel: 'Pagos de egresos',
    resultsFound: (count) => `Se encontraron ${count} pagos con los filtros actuales.`,
    noResultsMessage: 'No se encontraron pagos para proceder con la descarga.',
    documentTypeLabel: 'Tipo de documento a descargar',
    documentTypes: {
      pdf: 'PDF',
      xml: 'XML',
      both: 'PDF + XML',
    },
    groupByLabel: 'Agrupar por:',
    groupByOptions: {
      customer: 'Proveedor',
      month: 'Mes',
      none: 'Sin agrupar',
    },
    packageLimitHint: (limit) => `Límite por paquete: ${limit} pagos. Si se supera, se generarán múltiples paquetes automáticamente.`,
    expiryHint: (hours) => `Disponible durante ${hours} horas.`,
    availableUntil: (value) => `Disponible hasta ${value}.`,
    summaryLine: (documentType, count) => `${documentType} · ${count} pagos`,
    packageLine: (index, total) => `Paquete ${index} de ${total}`,
    preparing: {
      title: 'Preparando tu descarga',
      keepWorking: 'Puedes esperar aquí o cerrar esta ventana y continuar trabajando. La descarga seguirá preparándose aunque cierres esta ventana.',
      packageProgress: (completed, total) => `Preparando paquete ${Math.min(completed + 1, Math.max(total, 1))} de ${Math.max(total, 1)}...`,
    },
    expiredMessage: 'Descarga expirada. Los archivos de esta descarga ya no están disponibles.',
    status: {
      pending: 'Pendiente',
      processing: 'Preparando',
      completed: 'Listo',
      partialFailed: 'Parcial con errores',
      failed: 'Error',
      expired: 'Expirada',
    },
    actions: {
      close: 'Cerrar',
      refresh: 'Actualizar estado',
      download: 'Descargar',
      downloading: 'Descargando...',
      downloadPackage: 'Descargar',
      retryPackage: 'Reintentar',
      regenerate: 'Generar nuevamente',
    },
  },
  exports: {
    modal: {
      title: 'Exportar pagos',
      subtitle: 'Selecciona la información que deseas incluir en el archivo Excel. Puedes guardar esta configuración para utilizarla nuevamente.',
      format: {
        title: 'Formato de exportación',
        selectorLabel: 'Formato',
        selectorPlaceholder: 'Selecciona una opción',
        newOption: 'Nuevo formato',
        save: 'Guardar formato',
        saveAs: 'Guardar como',
        delete: 'Eliminar formato',
        saving: 'Guardando...',
        deleting: 'Eliminando...',
        nameLabel: 'Nombre del formato',
        namePlaceholder: 'Ej. Pagos timbrados',
        nameRequired: 'Debes capturar el nombre del formato.',
        duplicateConfirm: 'Ya existe un formato con ese nombre. ¿Deseas reemplazarlo?',
        deleteConfirm: '¿Deseas eliminar este formato de exportación?',
        copySuffix: 'copia',
      },
      columns: {
        title: 'Columnas a exportar',
        subtitle: 'Activa las columnas que deseas incluir en el archivo. El orden de selección se respeta en el Excel.',
        selectAll: 'Todas',
        clearSelection: 'Limpiar',
        restoreDefault: 'Restaurar',
        selectedCount: (count) => `${count} columna${count === 1 ? '' : 's'} seleccionada${count === 1 ? '' : 's'}`,
        fiscalDefaultWarning: 'La información de facturación depende del CFDI de pago timbrado; si no existe timbrado, algunos campos pueden estar vacíos.',
        orderTitle: 'Orden de columnas',
        orderSubtitle: 'Ajusta el orden con los controles de subir y bajar.',
        orderEmpty: 'No hay columnas seleccionadas.',
      },
      groups: {
        general: 'Información del pago',
        bank: 'Información bancaria',
        supplier: 'Proveedor y facturación',
        financial: 'Total y moneda',
        relation: 'Facturación y relación',
      },
      footer: {
        cancel: 'Cancelar',
        saveAndExport: 'Guardar y exportar',
        exportOnly: 'Exportar',
        exporting: 'Exportando...',
      },
      toast: {
        loadError: 'No fue posible cargar la configuración de exportación.',
        noColumns: 'Debes seleccionar al menos una columna para exportar.',
        formatSaved: 'Formato de exportación guardado correctamente.',
        formatUpdated: 'Formato de exportación actualizado correctamente.',
        formatDeleted: 'Formato de exportación eliminado correctamente.',
        formatError: 'No fue posible guardar el formato de exportación.',
        formatDeleteError: 'No fue posible eliminar el formato de exportación.',
        exportSuccess: 'Exportación de pagos generada correctamente.',
        exportError: 'No fue posible exportar los pagos.',
      },
    },
    settings: {
      deleteModal: {
        title: 'Eliminar formato de exportación',
        subtitle: 'Confirma para continuar con esta operación.',
        message: (formatName) => `Formato: ${formatName}. ¿Deseas eliminar este formato de exportación? Esta acción no se puede deshacer.`,
        confirm: 'Eliminar',
      },
      table: {
        actions: {
          delete: 'Eliminar',
        },
      },
    },
  },
  metrics: {
    totalCollected: 'Total cobrado',
    totalPending: 'Saldo por pagar',
    periodVariation: 'Variación del período %',
    averagePayment: 'Pago promedio',
  },
  toolbar: {
    searchPlaceholder: 'Buscar por proveedor, colaborador o total',
    filtersButtonTitle: 'Filtros',
    searchButtonTitle: 'Buscar',
    emptyOption: 'Sin opción disponible',
    dateRangePresets: [
      { key: 'this_month', label: 'Este mes' },
      { key: 'last_month', label: 'Mes anterior' },
      { key: 'this_year', label: 'Año actual' },
      { key: 'last_year', label: 'Año anterior' },
    ],
    allOptionLabels: {
      supplier: 'Proveedor: Todos',
      collaborator: 'Colaborador: Todos',
      paymentAccount: 'Todos',
    },
    selectionAllLabels: {
      supplier: 'Proveedor: Todos',
      collaborator: 'Colaborador: Todos',
      paymentAccount: 'Todos',
    },
    filters: {
      supplier: { label: 'Proveedor', placeholder: 'Selecciona proveedor', searchable: true },
      collaborator: { label: 'Colaborador', placeholder: 'Selecciona colaborador', searchable: true },
      paymentAccount: { label: 'Cuenta de pago', placeholder: 'Selecciona cuenta de pago', searchable: true },
    },
  },
  tabs: {
    all: 'Vigentes',
    cfdi: 'CFDI',
    simple_note: 'Nota Simple',
    canceled: 'Cancelados',
  },
  table: {
    loading: 'Cargando pagos...',
    empty: 'Sin pagos para los filtros seleccionados.',
    sortTitles: {
      date: 'Ordenar por fecha',
      supplier: 'Ordenar por proveedor',
      total: 'Ordenar por total',
    },
    columns: {
      date: 'FECHA',
      supplier: 'PROVEEDOR',
      folio: 'FOLIO',
      paymentAccount: 'CUENTA DE BANCO',
      total: 'TOTAL',
      status: 'ESTADO',
      actions: '',
    },
    labels: {
      exchangeRatePrefix: 'TC:',
      emptyValue: '',
      uuid: 'UUID',
      noUuid: 'SIN UUID',
    },
    actions: {
      view: 'Ver',
      download: 'Descargar',
      more: 'Más',
      downloadXml: 'Descargar XML',
      downloadPdf: 'Descargar PDF',
    },
    statusPills: {
      active: 'Vigente',
      canceled: 'Cancelado',
    },
  },
});
